<template>
  <div class="page-wrap">
    <div class="page-swipe">
      <van-nav-bar hidden
        title="我的订单"
      />

      <van-button class="btn-new" normal @click="makeOrder">
        <van-icon name="add-o"></van-icon> 新增订单
      </van-button>

      <van-tabs :active="active" sticky>
        <van-tab title="全部">
            <div v-for="(item, index) in all.list" :key="index" class="order-card">
              <van-cell >
                <template slot="title">
                  <div>
                    <van-icon name="contact" />
                     <span class="van-cell-text">{{item.name}}</span>
                     <span style="float:right;" >
                       <span style="color: #d2a725;font-size:12px;" v-if="item.isPaid" >{{getOrderState(item)}}</span>
                       <span style="color: red;font-size:12px;" v-else-if="item.pay_state === 'fail'">服务费{{item.pay_state_desc}}</span>
                       <span style="color: #d2a725;font-size:12px;" v-else>服务费{{item.pay_state_desc}}</span>
                       <span v-if="item.pay_state === 'pending'" style="color: #b1afaf;"> | <van-icon name="delete" @click="deleteOrder(item, index)"/></span>
                     </span>
                  </div>
                </template>
              </van-cell>
              <van-cell  @click="$router.push(`/order-confirm/${item.id}`)" class="cell-content">
                <template slot="title" >
                  <div class="content">
                    <span><span class="label">订单类型：</span>{{getType(item.payment_item, item.payment_way)}}</span>
                    <span><span class="label" v-if="item.payment_way === 'payback'">补缴周期：</span><span v-else class="label">挂靠周期：</span>{{format(item.payment_date_start)}} ~ {{format(item.payment_date_end)}}</span>
                  </div>
                </template>
              </van-cell>
              <van-cell class="cell-bill"  @click="$router.push(`/order-confirm/${item.id}`)" v-if="item.bill.period">
              <van-row>
                <van-col style="width: 64px;">
                  <div class="period" >
                    <span v-if="item.payment_way === 'payback'">补缴</span>
                    <span v-else>{{item.bill.period.substring(5, item.bill.period.length) + '月'}}</span>
                  </div>
                </van-col>

                <van-col span="8">
                    <span class="bill-item-month" >{{item.payment_item_desc}}代缴费</span>
                </van-col>
               <van-col span="5"><span class="bill-item-fee">￥{{item.bill.fee}}</span></van-col>
                <van-col  class="cell-bill-status-col" style="text-align: right;"><div class="cell-bill-status">
                <span :class="statusColor(item.bill.pay_state)" >{{status(item.bill.pay_state)}}</span>
                </div>
                </van-col>
              </van-row>
              </van-cell>

              <van-cell :title="item.created" >
                <div style="text-align:right;">

                    <van-button @click="renewSubmit(item)"  class=" renew-action" v-if="item.service_state === 'renew'" size="small" >续签</van-button>

                  <router-link :to="`/order-confirm/${item.id}`">
                    <van-button  class="order-action" size="small" v-if="needPay(item)">去支付</van-button>
                    <van-button  class="order-action" size="small" v-else>详情</van-button>
                  </router-link>
                </div>
              </van-cell>
            </div>
            <p class="no-data" v-if="all.list.length === 0">无订单数据</p>
        </van-tab>
        <van-tab title="待付款">
        <div v-for="(item, index) in pending.list" :key="item.id" class="order-card">
              <van-cell >
                <template slot="title">
                  <div>
                    <van-icon name="contact" />
                     <span class="van-cell-text">{{item.name}}</span>
                     <span style="float:right;" >
                       <span style="color: #d2a725;font-size:12px;" v-if="item.isPaid" >{{getOrderState(item)}}</span>
                       <span style="color: red;font-size:12px;" v-else-if="item.pay_state === 'fail'">服务费{{item.pay_state_desc}}</span>
                       <span style="color: #d2a725;font-size:12px;" v-else>服务费{{item.pay_state_desc}}</span>
                       <span v-if="item.pay_state === 'pending'" style="color: #b1afaf;"> | <van-icon name="delete" @click="deleteOrder(item, index)"/></span>
                     </span>
                   </div>
                </template>
              </van-cell>
              <van-cell  @click="$router.push(`/order-confirm/${item.id}`)" class="cell-content">
                <template slot="title" >
                  <div class="content">
                    <span><span class="label">订单类型：</span>{{getType(item.payment_item, item.payment_way)}}</span>
                    <span><span class="label" v-if="item.payment_way === 'payback'">补缴周期：</span><span v-else class="label">挂靠周期：</span>{{format(item.payment_date_start)}} ~ {{format(item.payment_date_end)}}</span>
                  </div>
                </template>
              </van-cell>
             <van-cell class="cell-bill"  @click="$router.push(`/order-confirm/${item.id}`)" v-if="item.bill.period">
              <van-row>
                <van-col style="width: 64px;">
                  <div class="period" >
                    <span v-if="item.payment_way === 'payback'">补缴</span>
                    <span v-else>{{item.bill.period.substring(5, item.bill.period.length) + '月'}}</span>
                  </div>
                </van-col>

                <van-col span="8">
                    <span class="bill-item-month" >{{item.payment_item_desc}}代缴费</span>
                </van-col>
               <van-col span="5"><span class="bill-item-fee">￥{{item.bill.fee}}</span></van-col>
                <van-col  class="cell-bill-status-col" style="text-align: right;"><div class="cell-bill-status">
                <span :class="statusColor(item.bill.pay_state)" >{{status(item.bill.pay_state)}}</span>
                </div>
                </van-col>
              </van-row>
              </van-cell>

              <van-cell :title="item.created" >
                <div style="text-align:right;">
                                      <van-button @click="renewSubmit(item)"  class=" renew-action" v-if="item.service_state === 'renew'" size="small" >续签</van-button>

                  <router-link :to="`/order-confirm/${item.id}`">
                    <van-button  class="order-action" size="small" v-if="needPay(item)">去支付</van-button>
                    <van-button  class="order-action" size="small" v-else>查看</van-button>
                  </router-link>
                </div>
              </van-cell>
            </div>
            <p class="no-data" v-if="pending.list.length === 0">无订单数据</p>
        </van-tab>
        <van-tab title="缴纳中" >
           <div v-for="(item, index) in added.list" :key="item.id" class="order-card" >
            <van-cell >
                <template slot="title">
                  <div>
                    <van-icon name="contact" />
                     <span class="van-cell-text">{{item.name}}</span>
                     <span style="float:right;" >
                       <span style="color: #d2a725;font-size:12px;" v-if="item.isPaid" >{{getOrderState(item)}}</span>
                       <span style="color: red;font-size:12px;" v-else-if="item.pay_state === 'fail'">服务费{{item.pay_state_desc}}</span>
                       <span style="color: #d2a725;font-size:12px;" v-else>服务费{{item.pay_state_desc}}</span>
                       <span v-if="item.pay_state === 'pending'" style="color: #b1afaf;"> | <van-icon name="delete" @click="deleteOrder(item, index)"/></span>
                     </span>
                   </div>
                </template>
              </van-cell>
              <van-cell  @click="$router.push(`/order-confirm/${item.id}`)" class="cell-content">
                <template slot="title" >
                  <div class="content">
                    <span><span class="label">订单类型：</span>{{getType(item.payment_item, item.payment_way)}}</span>
                    <span><span class="label" v-if="item.payment_way === 'payback'">补缴周期：</span><span v-else class="label">挂靠周期：</span>{{format(item.payment_date_start)}} ~ {{format(item.payment_date_end)}}</span>
                  </div>
                </template>
              </van-cell>
              <van-cell class="cell-bill"  @click="$router.push(`/order-confirm/${item.id}`)" v-if="item.bill.period">
              <van-row>
                <van-col style="width: 64px;">
                  <div class="period" >
                    <span v-if="item.payment_way === 'payback'">补缴</span>
                    <span v-else>{{item.bill.period.substring(5, item.bill.period.length) + '月'}}</span>
                  </div>
                </van-col>

                <van-col span="8">
                    <span class="bill-item-month" >{{item.payment_item_desc}}代缴费</span>
                </van-col>
               <van-col span="5"><span class="bill-item-fee">￥{{item.bill.fee}}</span></van-col>
                <van-col  class="cell-bill-status-col" style="text-align: right;"><div class="cell-bill-status">
                <span :class="statusColor(item.bill.pay_state)" >{{status(item.bill.pay_state)}}</span>
                </div>
                </van-col>
              </van-row>
              </van-cell>

              <van-cell :title="item.created" >
                <div style="text-align:right;">
                                      <van-button @click="renewSubmit(item)"  class=" renew-action" v-if="item.service_state === 'renew'" size="small" >续签</van-button>

                  <router-link :to="`/order-confirm/${item.id}`">
                    <van-button  class="order-action" size="small" v-if="needPay(item)">去支付</van-button>
                    <van-button  class="order-action" size="small" v-else>查看</van-button>
                  </router-link>
                </div>
              </van-cell>
            </div>
            <p class="no-data" v-if="added.list.length === 0">无订单数据</p>
        </van-tab>
        
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { NavBar,Button,Row,Col,Field,CellGroup,Toast,Checkbox, CheckboxGroup,Cell,Icon,Tab,Tabs,List, Dialog } from 'vant';
import {PaymentWay, PaymentItem, PaymentTerm, PayStatus, PayType, OrderStatus} from './util/state_desc';
import _ from 'lodash'
import moment from 'moment'
export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [List.name]: List,
    [Cell.name]: Cell
  },
  props: ['message'],
  name: 'orders',
  data: function() {
    return {
      active: 0,
      all: {
        page: 0,
        pageSize: 10,
        fetched: false,
        
        list: [],
        loading: false,
        finished: true
      },
      pending: {
        list: [] 
      },
      added: {
        list: [] 
      }
    }
  },
  mounted: function() {
   this.$router.replace('/order/list');
    //this.refresh();
    //this.active = this.$route.query.active || 0
  },
  methods: {
    goback: function() {
      this.$router.go(-1);
    },
    renewSubmit: function(item) {
      Dialog.confirm({
        confirmButtonText: '确认续签',
        cancelButtonText: '取消',
        message: '将根据该订单缴纳信息创建新订单并将挂靠周期往后续延，是否确认续签？'
      }).then(() => {
        let params = {}
        params.paid_shebao = 1
        params.profileid = item.profileid
        params.locations = item.locations
        params.shebao_baseline = item.shebao_baseline
        params.gongjijin_baseline = item.gongjijin_baseline
        params.payment_item = item.payment_item
        params.payment_term = item.payment_term
        params.payment_way = item.payment_way
        params.payment_date_start = moment(item.payment_date_end).add(1, 'month').format('YYYY-MM')
        params.census_type = item.census_type
        this.$http.post('/api/order/create', params).then(response => {
          if (response) {
            
            let data = response.data.data;
            if (data.code != 800){
              Toast("订单续签成功，请尽快付款");
              this.$router.replace({name: 'order-confirm', params: {orderid: data}});
            } else {
              Toast("续签失败，请稍后再试或手工新增下单");
            }
          }
        })

      }).catch(() => {
        // on cancel
      });;
    },
    refresh: function() {
      //获取全部的
      this.appendAll(false, true);
    },
    status: function(payState, state) {
      return PayStatus[payState];
    },
    statusColor: function(payState) {
        return 'status ' + payState
    },
    getOrderState: function(item) {
      return item.isPaid && (item.state === 'toreview' || item.state === 'pass' ) ? '办理中' : item.state_desc;
    },
    getType: function(item, way) {
      return PaymentItem[item] + PaymentWay[way];
    },
    format: function(date) {
      return moment(date).format("YYYY年MM月")
    },
    needPay: function(item) {
      let {pay_state} = item;
      //TODO 计算本月是否还有没有缴费的记录
      return pay_state == 'pending' || pay_state == 'fail'
         || item.bill.pay_state == 'pending'
         || item.bill.pay_state == 'fail';
    },
    deleteOrder: function(item, index) {
      Dialog.confirm({
        message: '是否确定删除该订单？'
      }).then(() => {
        this.$http.delete("/api/order/del", {params: {id: item.id}}).then( response => {
          if (response.data.errno === 0) {
            this.deleteById(this.all.list, item.id)
            this.deleteById(this.pending.list, item.id)
            this.deleteById(this.added.list, item.id)
            Toast("删除成功");
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    deleteById(list, id) {
      for (let i in list) {
        if (list[i].id === id) {
          list.splice(i, 1)
          break
        }
      }
    },
    appendAll: function(toast = true, reload = false) {
      if (reload) {
        this.all.page = 1;//添加页面
      } else {
        this.all.page += 1;//添加页面
      }
      this.$http.post("/api/order/search", {
        page: this.all.page,
        pageSize: 30
      }).then(response => {
        if (response){
          let {data} = response.data;
          if (_.isEmpty(data.data)) {
            if (toast) {
              Toast("没有记录了");
            }
            return;
          }
          if (reload) {
            this.all.list = data.data
          } else {
            this.all.list = _.concat(this.all.list, data.data);
          }
          this.all.fetched = true;//当前条件已经获取过了

          this.pending.list = this.all.list.filter( item => this.needPay(item))
          this.added.list = this.all.list.filter( item => item.state === 'added')
        }
      })
    },
    makeOrder: function() {
      this.$store.commit("stashProfile", {}, false);
      this.$router.push({name: 'basic-profile-init'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../assets/less/var.less";

  .van-cell {
    .van-icon {

    font-size: 13px;
    }
  }
  .load-more {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  

  .btn-new {
    display: block;
    width: 50%;
    text-align: center;
    margin: 20px auto;
    color: white;
    background-color: @defaultColor;

    .icon {
      width: 20px;
      height: 20px;
    }
  }
  .period {
    background-color:#38f;
    color: white;
    width: 28px;
    height: 28px;
    font-size: 0.7rem;
    line-height: 30px;
    border-radius: 31px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-weight: 500;
  }

  .order-card {
    margin-top: 20px;
    .content {
      font-size: 13px;
      &>span {
        display: block;
      }
    }
    .cell-content {
      background-color: #fbfbfb;
      :after {
        border-bottom-width: 0 !important;
      }

    }
    .cell-bill {
      padding: 8px 15px;
      padding-right: 0;
      line-height: 16px;

        .bill-item-month {
          font-size: 13px;
          color: gray;
          display: inline-block;
          text-align: left;
          line-height: 27px;
      }
      .bill-item-fee {
          font-weight:800;
          line-height: 27px;
          font-size: 13px;
        }
        .cell-bill-status-col {
              text-align: right;
    float: right;
    margin-right: 13px;
        }
      .cell-bill-status {
        text-align:right; 
        font-size: 12px;
    display: inline-block;
    float: right;
    color: #d2a725;
    line-height: 27px;
      }
    }
    .name {
      margin-right: 20px;
      min-width: 60px;
      display: inline-block;
    }
    .label {
      color: @defaultDescColor;
    }
    .van-icon-delete {
      font-size: 10px;
    }
    .order-action {
      color:#38f;
      height: 22px;
      padding: 0 0px;
      line-height: 22px;
    border:none;
    
    :after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid #38f;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 200%;
        height: 200%;
        border-radius: 24px;
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
        -webkit-transform-origin: left top;
        transform-origin: left top;
    }
    }
    .fail, .pending, .money {
      color: red;
    }
    .paid {
      color: #06bf04;
    }
  }

  .no-data {
    text-align: center;
    color: @defaultDescColor;
  }
    @media screen and (max-width: 320px) {
    .cell-bill-status {
          font-size: 10px !important;
    }
  }

  .renew-action {
           margin-right: 8px;
    line-height: 22px;
    color: white;
    border-radius: 23px;
    -webkit-transform-origin: left top;
    transform-origin: left top;
    height: 23px;
    border: none;
    background-color: #06bf04;
    
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/orders.vue